import {renderApp} from "@ui-seeker/app";

import App from "./App";

renderApp(App, {
    useServiceWorker: process?.env?.NODE_ENV === 'production'
});